import { Color } from "@constants/V2/color"
import { getColorHex } from "@utils/V2/color"
import React, { useEffect } from "react"

const ProductRating = ({
  skus = [],
  color = Color.Yellow,
  textColor,
}: {
  skus: string[]
  color?: Color
  textColor?: Color
}) => {
  useEffect(() => {
    const SNIPPET_SRC = "https://widget.reviews.io/rating-snippet/dist.js"
    const SNIPPET_CSS = "https://widget.reviews.io/rating-snippet/dist.css"

    const initSnippet = () => {
      if (
        typeof globalThis !== "undefined" &&
        (globalThis as any).ratingSnippet
      ) {
        ;(globalThis as any).ratingSnippet("ruk_rating_snippet", {
          store: "www.yoco.com",
          mode: "default",
          color: getColorHex(color),
          linebreak: false,
          text: "Reviews",
          singularText: "Review",
          lang: "en",
          usePolaris: false,
          showEmptyStars: false,
          showNumericalAverageRating: false,
        })
      }
    }

    if (!document.querySelector(`link[href="${SNIPPET_CSS}"]`)) {
      const link = document.createElement("link")
      link.rel = "stylesheet"
      link.href = SNIPPET_CSS
      document.head.appendChild(link)
    }

    const existingScript = document.querySelector(
      `script[src="${SNIPPET_SRC}"]`
    )
    if (existingScript) {
      initSnippet()
      return
    }

    const script = document.createElement("script")
    script.src = SNIPPET_SRC
    script.async = true
    script.onload = initSnippet
    document.body.appendChild(script)
  }, [])

  const handleClick = () => {
    const reviewsWidget = document.getElementById("ReviewsWidget")
    if (reviewsWidget) {
      reviewsWidget.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <button
      className="ruk_rating_snippet mr-auto block"
      style={
        textColor
          ? ({
              "--rating-count-color": getColorHex(textColor),
            } as React.CSSProperties)
          : undefined
      }
      data-sku={skus.join(";")}
      onClick={handleClick}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          handleClick()
        }
      }}
    />
  )
}

export default ProductRating
